import React from 'react';
import EpoxyStepper from './components/EpoxyStepper';
import './styles/form.css';

function App() {
  return <EpoxyStepper />;
}

export default App;
